/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscriptionEndedRouteImport } from './routes/subscription-ended'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignupBetaRouteImport } from './routes/signup.beta'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsMembersRouteImport } from './routes/settings.members'
import { Route as InviteAcceptRouteImport } from './routes/invite.accept'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminReadinessRouteImport } from './routes/admin.readiness'
import { Route as AdminRbacRouteImport } from './routes/admin.rbac'
import { Route as AdminOutreachRouteImport } from './routes/admin.outreach'
import { Route as AdminFundersRouteImport } from './routes/admin.funders'
import { Route as ProjectsProjectIdWorkspaceRouteImport } from './routes/projects.$projectId.workspace'
import { Route as ProjectsProjectIdWorkspaceTabRouteImport } from './routes/projects.$projectId.workspace.$tab'
import { Route as ProjectsProjectIdIntakeSubmitRouteImport } from './routes/projects.$projectId.intake.submit'
import { Route as ProjectsProjectIdIntakeStepRouteImport } from './routes/projects.$projectId.intake.$step'
import { Route as ProjectsProjectIdImpactSnapshotIdRouteImport } from './routes/projects.$projectId.impact.$snapshotId'
import { Route as ProjectsProjectIdAuditAuditIdRouteImport } from './routes/projects.$projectId.audit.$auditId'

const SubscriptionEndedRoute = SubscriptionEndedRouteImport.update({
  id: '/subscription-ended',
  path: '/subscription-ended',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupBetaRoute = SignupBetaRouteImport.update({
  id: '/signup/beta',
  path: '/signup/beta',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsProfileRoute = SettingsProfileRouteImport.update({
  id: '/settings/profile',
  path: '/settings/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsMembersRoute = SettingsMembersRouteImport.update({
  id: '/settings/members',
  path: '/settings/members',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteAcceptRoute = InviteAcceptRouteImport.update({
  id: '/invite/accept',
  path: '/invite/accept',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminReadinessRoute = AdminReadinessRouteImport.update({
  id: '/admin/readiness',
  path: '/admin/readiness',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRbacRoute = AdminRbacRouteImport.update({
  id: '/admin/rbac',
  path: '/admin/rbac',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOutreachRoute = AdminOutreachRouteImport.update({
  id: '/admin/outreach',
  path: '/admin/outreach',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminFundersRoute = AdminFundersRouteImport.update({
  id: '/admin/funders',
  path: '/admin/funders',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdWorkspaceRoute =
  ProjectsProjectIdWorkspaceRouteImport.update({
    id: '/projects/$projectId/workspace',
    path: '/projects/$projectId/workspace',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdWorkspaceTabRoute =
  ProjectsProjectIdWorkspaceTabRouteImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => ProjectsProjectIdWorkspaceRoute,
  } as any)
const ProjectsProjectIdIntakeSubmitRoute =
  ProjectsProjectIdIntakeSubmitRouteImport.update({
    id: '/projects/$projectId/intake/submit',
    path: '/projects/$projectId/intake/submit',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdIntakeStepRoute =
  ProjectsProjectIdIntakeStepRouteImport.update({
    id: '/projects/$projectId/intake/$step',
    path: '/projects/$projectId/intake/$step',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdImpactSnapshotIdRoute =
  ProjectsProjectIdImpactSnapshotIdRouteImport.update({
    id: '/projects/$projectId/impact/$snapshotId',
    path: '/projects/$projectId/impact/$snapshotId',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdAuditAuditIdRoute =
  ProjectsProjectIdAuditAuditIdRouteImport.update({
    id: '/projects/$projectId/audit/$auditId',
    path: '/projects/$projectId/audit/$auditId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/admin/funders': typeof AdminFundersRoute
  '/admin/outreach': typeof AdminOutreachRoute
  '/admin/rbac': typeof AdminRbacRoute
  '/admin/readiness': typeof AdminReadinessRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/signup/beta': typeof SignupBetaRoute
  '/projects/$projectId/workspace': typeof ProjectsProjectIdWorkspaceRouteWithChildren
  '/projects/$projectId/audit/$auditId': typeof ProjectsProjectIdAuditAuditIdRoute
  '/projects/$projectId/impact/$snapshotId': typeof ProjectsProjectIdImpactSnapshotIdRoute
  '/projects/$projectId/intake/$step': typeof ProjectsProjectIdIntakeStepRoute
  '/projects/$projectId/intake/submit': typeof ProjectsProjectIdIntakeSubmitRoute
  '/projects/$projectId/workspace/$tab': typeof ProjectsProjectIdWorkspaceTabRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/admin/funders': typeof AdminFundersRoute
  '/admin/outreach': typeof AdminOutreachRoute
  '/admin/rbac': typeof AdminRbacRoute
  '/admin/readiness': typeof AdminReadinessRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/signup/beta': typeof SignupBetaRoute
  '/projects/$projectId/workspace': typeof ProjectsProjectIdWorkspaceRouteWithChildren
  '/projects/$projectId/audit/$auditId': typeof ProjectsProjectIdAuditAuditIdRoute
  '/projects/$projectId/impact/$snapshotId': typeof ProjectsProjectIdImpactSnapshotIdRoute
  '/projects/$projectId/intake/$step': typeof ProjectsProjectIdIntakeStepRoute
  '/projects/$projectId/intake/submit': typeof ProjectsProjectIdIntakeSubmitRoute
  '/projects/$projectId/workspace/$tab': typeof ProjectsProjectIdWorkspaceTabRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/subscription-ended': typeof SubscriptionEndedRoute
  '/admin/funders': typeof AdminFundersRoute
  '/admin/outreach': typeof AdminOutreachRoute
  '/admin/rbac': typeof AdminRbacRoute
  '/admin/readiness': typeof AdminReadinessRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/invite/accept': typeof InviteAcceptRoute
  '/settings/members': typeof SettingsMembersRoute
  '/settings/profile': typeof SettingsProfileRoute
  '/signup/beta': typeof SignupBetaRoute
  '/projects/$projectId/workspace': typeof ProjectsProjectIdWorkspaceRouteWithChildren
  '/projects/$projectId/audit/$auditId': typeof ProjectsProjectIdAuditAuditIdRoute
  '/projects/$projectId/impact/$snapshotId': typeof ProjectsProjectIdImpactSnapshotIdRoute
  '/projects/$projectId/intake/$step': typeof ProjectsProjectIdIntakeStepRoute
  '/projects/$projectId/intake/submit': typeof ProjectsProjectIdIntakeSubmitRoute
  '/projects/$projectId/workspace/$tab': typeof ProjectsProjectIdWorkspaceTabRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/reset'
    | '/subscription-ended'
    | '/admin/funders'
    | '/admin/outreach'
    | '/admin/rbac'
    | '/admin/readiness'
    | '/auth/callback'
    | '/invite/accept'
    | '/settings/members'
    | '/settings/profile'
    | '/signup/beta'
    | '/projects/$projectId/workspace'
    | '/projects/$projectId/audit/$auditId'
    | '/projects/$projectId/impact/$snapshotId'
    | '/projects/$projectId/intake/$step'
    | '/projects/$projectId/intake/submit'
    | '/projects/$projectId/workspace/$tab'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/reset'
    | '/subscription-ended'
    | '/admin/funders'
    | '/admin/outreach'
    | '/admin/rbac'
    | '/admin/readiness'
    | '/auth/callback'
    | '/invite/accept'
    | '/settings/members'
    | '/settings/profile'
    | '/signup/beta'
    | '/projects/$projectId/workspace'
    | '/projects/$projectId/audit/$auditId'
    | '/projects/$projectId/impact/$snapshotId'
    | '/projects/$projectId/intake/$step'
    | '/projects/$projectId/intake/submit'
    | '/projects/$projectId/workspace/$tab'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/register'
    | '/reset'
    | '/subscription-ended'
    | '/admin/funders'
    | '/admin/outreach'
    | '/admin/rbac'
    | '/admin/readiness'
    | '/auth/callback'
    | '/invite/accept'
    | '/settings/members'
    | '/settings/profile'
    | '/signup/beta'
    | '/projects/$projectId/workspace'
    | '/projects/$projectId/audit/$auditId'
    | '/projects/$projectId/impact/$snapshotId'
    | '/projects/$projectId/intake/$step'
    | '/projects/$projectId/intake/submit'
    | '/projects/$projectId/workspace/$tab'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetRoute: typeof ResetRoute
  SubscriptionEndedRoute: typeof SubscriptionEndedRoute
  AdminFundersRoute: typeof AdminFundersRoute
  AdminOutreachRoute: typeof AdminOutreachRoute
  AdminRbacRoute: typeof AdminRbacRoute
  AdminReadinessRoute: typeof AdminReadinessRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  InviteAcceptRoute: typeof InviteAcceptRoute
  SettingsMembersRoute: typeof SettingsMembersRoute
  SettingsProfileRoute: typeof SettingsProfileRoute
  SignupBetaRoute: typeof SignupBetaRoute
  ProjectsProjectIdWorkspaceRoute: typeof ProjectsProjectIdWorkspaceRouteWithChildren
  ProjectsProjectIdAuditAuditIdRoute: typeof ProjectsProjectIdAuditAuditIdRoute
  ProjectsProjectIdImpactSnapshotIdRoute: typeof ProjectsProjectIdImpactSnapshotIdRoute
  ProjectsProjectIdIntakeStepRoute: typeof ProjectsProjectIdIntakeStepRoute
  ProjectsProjectIdIntakeSubmitRoute: typeof ProjectsProjectIdIntakeSubmitRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscription-ended': {
      id: '/subscription-ended'
      path: '/subscription-ended'
      fullPath: '/subscription-ended'
      preLoaderRoute: typeof SubscriptionEndedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/beta': {
      id: '/signup/beta'
      path: '/signup/beta'
      fullPath: '/signup/beta'
      preLoaderRoute: typeof SignupBetaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/profile': {
      id: '/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof SettingsProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/members': {
      id: '/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof SettingsMembersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/accept': {
      id: '/invite/accept'
      path: '/invite/accept'
      fullPath: '/invite/accept'
      preLoaderRoute: typeof InviteAcceptRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/readiness': {
      id: '/admin/readiness'
      path: '/admin/readiness'
      fullPath: '/admin/readiness'
      preLoaderRoute: typeof AdminReadinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/rbac': {
      id: '/admin/rbac'
      path: '/admin/rbac'
      fullPath: '/admin/rbac'
      preLoaderRoute: typeof AdminRbacRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/outreach': {
      id: '/admin/outreach'
      path: '/admin/outreach'
      fullPath: '/admin/outreach'
      preLoaderRoute: typeof AdminOutreachRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/funders': {
      id: '/admin/funders'
      path: '/admin/funders'
      fullPath: '/admin/funders'
      preLoaderRoute: typeof AdminFundersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/workspace': {
      id: '/projects/$projectId/workspace'
      path: '/projects/$projectId/workspace'
      fullPath: '/projects/$projectId/workspace'
      preLoaderRoute: typeof ProjectsProjectIdWorkspaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/workspace/$tab': {
      id: '/projects/$projectId/workspace/$tab'
      path: '/$tab'
      fullPath: '/projects/$projectId/workspace/$tab'
      preLoaderRoute: typeof ProjectsProjectIdWorkspaceTabRouteImport
      parentRoute: typeof ProjectsProjectIdWorkspaceRoute
    }
    '/projects/$projectId/intake/submit': {
      id: '/projects/$projectId/intake/submit'
      path: '/projects/$projectId/intake/submit'
      fullPath: '/projects/$projectId/intake/submit'
      preLoaderRoute: typeof ProjectsProjectIdIntakeSubmitRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/intake/$step': {
      id: '/projects/$projectId/intake/$step'
      path: '/projects/$projectId/intake/$step'
      fullPath: '/projects/$projectId/intake/$step'
      preLoaderRoute: typeof ProjectsProjectIdIntakeStepRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/impact/$snapshotId': {
      id: '/projects/$projectId/impact/$snapshotId'
      path: '/projects/$projectId/impact/$snapshotId'
      fullPath: '/projects/$projectId/impact/$snapshotId'
      preLoaderRoute: typeof ProjectsProjectIdImpactSnapshotIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/audit/$auditId': {
      id: '/projects/$projectId/audit/$auditId'
      path: '/projects/$projectId/audit/$auditId'
      fullPath: '/projects/$projectId/audit/$auditId'
      preLoaderRoute: typeof ProjectsProjectIdAuditAuditIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface ProjectsProjectIdWorkspaceRouteChildren {
  ProjectsProjectIdWorkspaceTabRoute: typeof ProjectsProjectIdWorkspaceTabRoute
}

const ProjectsProjectIdWorkspaceRouteChildren: ProjectsProjectIdWorkspaceRouteChildren =
  {
    ProjectsProjectIdWorkspaceTabRoute: ProjectsProjectIdWorkspaceTabRoute,
  }

const ProjectsProjectIdWorkspaceRouteWithChildren =
  ProjectsProjectIdWorkspaceRoute._addFileChildren(
    ProjectsProjectIdWorkspaceRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetRoute: ResetRoute,
  SubscriptionEndedRoute: SubscriptionEndedRoute,
  AdminFundersRoute: AdminFundersRoute,
  AdminOutreachRoute: AdminOutreachRoute,
  AdminRbacRoute: AdminRbacRoute,
  AdminReadinessRoute: AdminReadinessRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  InviteAcceptRoute: InviteAcceptRoute,
  SettingsMembersRoute: SettingsMembersRoute,
  SettingsProfileRoute: SettingsProfileRoute,
  SignupBetaRoute: SignupBetaRoute,
  ProjectsProjectIdWorkspaceRoute: ProjectsProjectIdWorkspaceRouteWithChildren,
  ProjectsProjectIdAuditAuditIdRoute: ProjectsProjectIdAuditAuditIdRoute,
  ProjectsProjectIdImpactSnapshotIdRoute:
    ProjectsProjectIdImpactSnapshotIdRoute,
  ProjectsProjectIdIntakeStepRoute: ProjectsProjectIdIntakeStepRoute,
  ProjectsProjectIdIntakeSubmitRoute: ProjectsProjectIdIntakeSubmitRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
